import { useState } from 'react';
import { ShieldPlus } from 'lucide-react';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

type Props = {
  triggerNode: React.ReactNode;
  onGetAddOn: () => void;
  isLoading?: boolean;
  price: number;
  description: string;
  title?: string;
  noteText?: string;
};

const defaultTitle = 'Get Verified';
const defaultNoteText = 'Added to the owner’s subscription. Regional pricing may apply.';

const GetVerifiedLevelDialog = ({
  triggerNode,
  onGetAddOn,
  isLoading,
  price,
  description,
  title = defaultTitle,
  noteText = defaultNoteText,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const onLearnMore = () => window.open('https://codekeeper.co/verification', '_blank');

  const handleAddOn = async () => {
    await onGetAddOn();
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>{triggerNode}</DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <ShieldPlus className="size-8" />
        <DialogHeader className="gap-1.5">
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <div className="text-muted-foreground">
          <div className="text-sm mb-2.5">From</div>
          <div className="flex items-end gap-1 mb-6">
            <strong className="text-4xl text-secondary-foreground font-extrabold">${price}</strong>
            <strong className="text-2xl ">/mo</strong>
          </div>
          <p className="text-xs">{noteText}</p>
        </div>
        <DialogFooter className="sm:justify-between">
          <Button variant="secondary" size="sm" onClick={onLearnMore}>
            Learn more
          </Button>
          <Button size="sm" onClick={handleAddOn} isLoading={isLoading}>
            Get Add-on
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default GetVerifiedLevelDialog;
